import { Mapping } from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import {
  isModelConceptClass,
  isModelConceptRelationshipLabel,
} from 'src/containers/ProjectDiagram/utils/data';

/** updates the data bindings on the Mapping's `to` node */
export const doMappingUpdated = (mapping: Mapping) => (model: Model) => {
  // Call updateTargetBindings with the Mapping's `to` node.
  // This is so that our ModelConceptClass/ModelConceptRelationshipLabel
  // visually update when the Mapping changes.
  const toData =
    mapping.to &&
    model.nodeDataArray.find(
      (nodeData) =>
        (isModelConceptClass(nodeData) ||
          isModelConceptRelationshipLabel(nodeData)) &&
        nodeData.key === mapping.to
    );
  if (toData) {
    model.updateTargetBindings(toData);
  }
};
